import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  closeModal,
  getRandomColor,
  isBlank,
  submitAnnualPlannerAction,
} from "../../../utils/annual-planner-helpers";
import InputColor from "../../../views/dashboard/settings/branding/InputColor";
import Modal from "../../modal-new";

export const AddIndividualPhaseModal = ({
  athleteId,
  organizationCoachId,
  track = "training",
}) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const [phasesState, setPhasesState] = useState([
    { phaseName: "", phaseColor: getRandomColor() },
  ]);

  const [emptyPhasesState, setEmptyPhasesState] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    const emptyPhases = phasesState.find((phase) => isBlank(phase.phaseName));
    if (emptyPhases) return;

    submitAnnualPlannerAction(
      "/actions/annual-planner/set-athlete-phases",
      { phases: phasesState, athleteId, track },
      organizationCoachId
    );
  };

  useEffect(() => {
    const emptyPhases = phasesState.some((phase) => isBlank(phase.phaseName));
    setEmptyPhasesState(emptyPhases);
  }, [phasesState]);

  const handleChange = (input, payload, index = false) => {
    if (index !== false) {
      const newPhases = Array.from(phasesState);
      newPhases[index][input] = String(payload);
      return setPhasesState(newPhases);
    }
  };

  const handleAddPhase = () => {
    const newPhases = Array.from(phasesState);
    newPhases.push({ phaseName: "", phaseColor: getRandomColor() });
    setPhasesState(newPhases);
  };

  const handleRemovePhase = (index) => {
    const newPhases = Array.from(phasesState);
    newPhases.splice(index, 1);
    setPhasesState(newPhases);
  };

  const titleKey =
    track === "nutrition"
      ? "addIndividualPhaseModal.titleNutritionPhase"
      : "addIndividualPhaseModal.titleTrainingPhase";

  return (
    <Modal
      className="annual-planner-modal add-individual-phase-modal"
      title={t(titleKey)}
    >
      <div className="body">
        <form
          className="annual-planner-modal-form add-individual-phase-modal-form"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          id="individual-phase-form"
        >
          <div role="wrapper" className="phases-labels">
            <label>{t("addIndividualPhaseModal.phaseNameLabel")}</label>
            <label>{t("addIndividualPhaseModal.colorLabel")}</label>
          </div>
          {phasesState.map((phase, index) => (
            <div role="wrapper" className="phase" key={`ind-phase-${index}`}>
              <input
                type={"text"}
                id={`phaseName${index}`}
                name={"phaseName"}
                className="phase-name text-input"
                placeholder={t("addIndividualPhaseModal.placeholderPhaseName")}
                defaultValue={phase.phaseName}
                onChange={({ target: { value } }) =>
                  handleChange("phaseName", value, index)
                }
              />
              <InputColor
                onChange={({ target: { value } }) =>
                  handleChange("phaseColor", value, index)
                }
                value={phase.phaseColor}
                customClassNames={"phase-color"}
              />
              <img
                src="/img/new-icons/red-trash.svg"
                onClick={() => handleRemovePhase(index)}
                role="remove"
              />
            </div>
          ))}
          <div className="add-phase-row-wrapper">
            <button
              type="button"
              className="btn-add-phase"
              onClick={handleAddPhase}
            >
              <span>{t("addIndividualPhaseModal.addNew")}</span>
            </button>
          </div>
        </form>
      </div>
      <footer className="individual-phase-footer">
        <button
          type="button"
          role="button"
          data-action="cancel"
          onClick={closeModal}
        >
          {t("common:cancel")}
        </button>
        <button
          form="individual-phase-form"
          type="submit"
          disabled={emptyPhasesState}
          role="button"
          data-button-type="primary"
        >
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
};
